import AccountSection from "../components/AccountSection";
import UserImg from "../assets/leadership/Savchenko.png";
import MainLayouts from "../layouts/MainLayouts";
import { useTranslation } from "react-i18next";
import UserModel from "../models/UserModel";
import { useState, useEffect } from 'react';
import { userServiceFactory } from "../services/UserServiceImpl";


export default function Account() {
const { t } = useTranslation();
const [user, setUser] = useState<UserModel | null>(null);

useEffect(() => {
  const loadUser = async () => {
    const userService = userServiceFactory();
    const apiResponse = await userService.getUser();
    setUser(new UserModel(apiResponse));
  };

  loadUser();
}, []);

    return ( 
        <MainLayouts pageTitle={t("account.pageTitle")}>
            <div className="flex flex-col gap-[80px] md:gap-[90px] lg:gap-[100px] lg:pb-[80px] pb-[90px]">
                 
                {user && (
                    <AccountSection
                        user={user}
                        imgSrc={UserImg}
                        onUserUpdated={(updatedUser) => setUser(updatedUser)}
                    />
                )}
                    
            </div>
        </MainLayouts>
    );
}